import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderInfoItemWrapperComponent = _resolveComponent("OrderInfoItemWrapperComponent")!
  const _component_TransportationStopsModalContentComponent = _resolveComponent("TransportationStopsModalContentComponent")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_OrderInfoItemWrapperComponent, {
        "data-class-name": '__data-1',
        "translate-key": 'drive_from'
      }, {
        "icon-item": _withCtx(() => _cache[4] || (_cache[4] = [
          _createElementVNode("img", {
            src: "/assets/images/Framelocation-icon.png",
            alt: "location"
          }, null, -1)
        ])),
        "order-info": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.orderData.forwardTicket.pickUp.address_to_show) + ", " + _toDisplayString(_ctx.orderData.forwardTicket.pickUp.city) + " " + _toDisplayString((_ctx.orderData.forwardTicket.pickup_specified_address.length > 0) ? `(${_ctx.orderData.forwardTicket.pickup_specified_address})` : ''), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_OrderInfoItemWrapperComponent, {
        "data-class-name": '__data-2',
        "translate-key": 'departure'
      }, {
        "icon-item": _withCtx(() => _cache[5] || (_cache[5] = [
          _createElementVNode("img", {
            src: "/assets/images/Framecalendar-icon.png",
            alt: "pickup-date-time"
          }, null, -1)
        ])),
        "order-info": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.dateHelpers.dateToDisplay(_ctx.orderData.forwardTicket.tripDate)) + " " + _toDisplayString(_ctx.tripTimeForward.departure), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_OrderInfoItemWrapperComponent, {
        "data-class-name": '__data-3',
        "translate-key": 'stops',
        "data-bs-toggle": "modal",
        "data-bs-target": `#transportation-route-map-${_ctx.orderData.forwardTicket.data.id}`
      }, {
        "icon-item": _withCtx(() => [
          _createElementVNode("img", {
            src: "/assets/images/plus-circle-plus-svg.svg",
            alt: "end-date-time",
            onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onHover($event))),
            onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onUnHover($event)))
          }, null, 32)
        ]),
        "order-info": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.orderData.forwardTicket.data.transportation_stop.length), 1)
        ]),
        _: 1
      }, 8, ["data-bs-target"]),
      _createVNode(_component_OrderInfoItemWrapperComponent, {
        "data-class-name": '__data-4',
        "translate-key": 'arrival'
      }, {
        "icon-item": _withCtx(() => _cache[6] || (_cache[6] = [
          _createElementVNode("img", {
            src: "/assets/images/Framecalendar-icon.png",
            alt: "end-date-time"
          }, null, -1)
        ])),
        "order-info": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.dateHelpers.dateToDisplay(_ctx.orderData.forwardTicket.tripDate)) + " " + _toDisplayString(_ctx.tripTimeForward.arrival), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_OrderInfoItemWrapperComponent, {
        "data-class-name": '__data-5',
        "translate-key": 'drive_to'
      }, {
        "icon-item": _withCtx(() => _cache[7] || (_cache[7] = [
          _createElementVNode("img", {
            src: "/assets/images/Framedestination.png",
            alt: "end-date-time"
          }, null, -1)
        ])),
        "order-info": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.orderData.forwardTicket.dropOff.address_to_show) + ", " + _toDisplayString(_ctx.orderData.forwardTicket.dropOff.city) + " " + _toDisplayString((_ctx.orderData.forwardTicket.dropoff_specified_address.length > 0) ? `(${_ctx.orderData.forwardTicket.dropoff_specified_address})` : ''), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_OrderInfoItemWrapperComponent, {
        "data-class-name": '__data-6',
        "translate-key": 'passengers'
      }, {
        "icon-item": _withCtx(() => _cache[8] || (_cache[8] = [
          _createElementVNode("img", {
            src: "/assets/images/Framepeople-icon.png",
            alt: "people-count"
          }, null, -1)
        ])),
        "order-info": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.orderData.tripPassengers), 1)
        ]),
        _: 1
      })
    ]),
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-sm-12 col-md-12 col-lg-11 hr-line" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_OrderInfoItemWrapperComponent, {
        "data-class-name": '__data-1',
        "translate-key": 'drive_from'
      }, {
        "icon-item": _withCtx(() => _cache[9] || (_cache[9] = [
          _createElementVNode("img", {
            src: "/assets/images/Framelocation-icon.png",
            alt: "location"
          }, null, -1)
        ])),
        "order-info": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.orderData.backTicket.pickUp.address_to_show) + ", " + _toDisplayString(_ctx.orderData.backTicket.pickUp.city) + " " + _toDisplayString((_ctx.orderData.backTicket.pickup_specified_address.length > 0) ? `(${_ctx.orderData.backTicket.pickup_specified_address})` : ''), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_OrderInfoItemWrapperComponent, {
        "data-class-name": '__data-2',
        "translate-key": 'departure'
      }, {
        "icon-item": _withCtx(() => _cache[10] || (_cache[10] = [
          _createElementVNode("img", {
            src: "/assets/images/Framecalendar-icon.png",
            alt: "pickup-date-time"
          }, null, -1)
        ])),
        "order-info": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.dateHelpers.dateToDisplay(_ctx.orderData.backTicket.tripDate)) + " " + _toDisplayString(_ctx.tripTimeBack.departure), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_OrderInfoItemWrapperComponent, {
        "data-class-name": '__data-3',
        "translate-key": 'stops',
        "data-bs-toggle": "modal",
        "data-bs-target": `#transportation-route-map-${_ctx.orderData.backTicket.data.id}`
      }, {
        "icon-item": _withCtx(() => [
          _createElementVNode("img", {
            src: "/assets/images/plus-circle-plus-svg.svg",
            alt: "end-date-time",
            onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onHover($event))),
            onMouseout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onUnHover($event)))
          }, null, 32)
        ]),
        "order-info": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.orderData.backTicket.data.transportation_stop.length), 1)
        ]),
        _: 1
      }, 8, ["data-bs-target"]),
      _createVNode(_component_OrderInfoItemWrapperComponent, {
        "data-class-name": '__data-4',
        "translate-key": 'arrival'
      }, {
        "icon-item": _withCtx(() => _cache[11] || (_cache[11] = [
          _createElementVNode("img", {
            src: "/assets/images/Framecalendar-icon.png",
            alt: "end-date-time"
          }, null, -1)
        ])),
        "order-info": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.dateHelpers.dateToDisplay(_ctx.orderData.backTicket.tripDate)) + " " + _toDisplayString(_ctx.tripTimeBack.arrival), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_OrderInfoItemWrapperComponent, {
        "data-class-name": '__data-5',
        "translate-key": 'drive_to'
      }, {
        "icon-item": _withCtx(() => _cache[12] || (_cache[12] = [
          _createElementVNode("img", {
            src: "/assets/images/Framedestination.png",
            alt: "end-date-time"
          }, null, -1)
        ])),
        "order-info": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.orderData.backTicket.dropOff.address_to_show) + ", " + _toDisplayString(_ctx.orderData.backTicket.dropOff.city) + " " + _toDisplayString((_ctx.orderData.backTicket.dropoff_specified_address.length > 0) ? `(${_ctx.orderData.backTicket.dropoff_specified_address})` : ''), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_OrderInfoItemWrapperComponent, {
        "data-class-name": '__data-6',
        "translate-key": 'passengers'
      }, {
        "icon-item": _withCtx(() => _cache[13] || (_cache[13] = [
          _createElementVNode("img", {
            src: "/assets/images/Framepeople-icon.png",
            alt: "people-count"
          }, null, -1)
        ])),
        "order-info": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.orderData.tripPassengers), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_ModalComponent, {
      "show-title": false,
      "id-data": `transportation-route-map-${_ctx.orderData.forwardTicket.data.id}`
    }, {
      "body-content": _withCtx(() => [
        _createVNode(_component_TransportationStopsModalContentComponent, {
          data: _ctx.orderData.forwardTicket.data
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["id-data"]),
    _createVNode(_component_ModalComponent, {
      "show-title": false,
      "id-data": `transportation-route-map-${_ctx.orderData.backTicket.data.id}`
    }, {
      "body-content": _withCtx(() => [
        _createVNode(_component_TransportationStopsModalContentComponent, {
          data: _ctx.orderData.backTicket.data
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["id-data"]),
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-sm-12 col-md-12 col-lg-11 hr-line" }, null, -1))
  ], 64))
}